import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBfzHrv8jpx-UZR74XRFqWoVYxVbccFV5g",
  authDomain: "canteen-locator-system.firebaseapp.com",
  projectId: "canteen-locator-system",
  storageBucket: "canteen-locator-system.appspot.com",
  messagingSenderId: "916678643385",
  appId: "1:916678643385:web:fdbd51960bbbc944f59568",
  measurementId: "G-XHSDYFEW1P",
};

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();

export { auth };
